export class ASCII {
    public static format(str: string): string {
        return str.replaceAll(/[^\x00-\xFE]+/g, '');
    }

    public static isValid(str: string): boolean {
        return /^[\x00-\xFE]*$/g.test(str);
    }
}
